<div style="margin: 2rem;">
  <div>
    <h1> Provedores </h1>
  </div>
</div>



<form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
  <mat-card class="standard-card">  
    
  <mat-card-content>
    <div class="row">
      <div class="col">
        <mat-form-field class="full-width">
          <input matInput placeholder="ID" formControlName="id">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field class="full-width">
          <input matInput placeholder="Servico" formControlName="servico">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field class="full-width">
          <input matInput placeholder="Nome" formControlName="nome">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field class="full-width">
          <input matInput placeholder="Abreviacao" formControlName="alias">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field class="full-width">
          <input matInput placeholder="Tipo" formControlName="tipo">
        </mat-form-field>
      </div>
    </div>


    <div class="row">
      <div class="col">
        <mat-form-field class="full-width">
          <input matInput placeholder="url" formControlName="url">
        </mat-form-field>
      </div>
    </div>


  </mat-card-content>
  <mat-card-actions>
    <button mat-stroked-button matTooltipClass="tooltip-blue" (click)="voltarProvedor()" color="primary">Cancelar</button> &nbsp;        
    <button *ngIf="acao=='edit' || acao=='new'" mat-raised-button matTooltipClass="tooltip-blue" (click)="updateProvedor(profileForm.value,profileForm.value.id)" color="primary">Gravar</button> &nbsp;        
    <button *ngIf="acao=='delete'" mat-raised-button matTooltipClass="tooltip-blue" (click)="deleteProvedor()" color="warn">Confirma exlusão?</button> &nbsp;        
  </mat-card-actions>  
</mat-card>
</form>

  
  
  

  